<script setup lang="ts">
import { TEST_IDS_CREATE } from '@/_testIds/testIdsCreate'
import CollapsableContent from '@/components/common/layout/CollapsableContent.vue'
import SectionAddresses from '@/components/editRelationGroup/sections/SectionAddresses.vue'
import SectionEmails from '@/components/editRelationGroup/sections/SectionEmails.vue'
import SectionGeneralDataPerson from '@/components/editRelationGroup/sections/SectionGeneralDataPerson.vue'
import SectionMetaData from '@/components/editRelationGroup/sections/SectionMetaData.vue'
import SectionPhoneNumbers from '@/components/editRelationGroup/sections/SectionPhoneNumbers.vue'
import SectionWeblinks from '@/components/editRelationGroup/sections/SectionWeblinks.vue'
import { useTagOptions } from '@/composables/useTagOptions'
import { translationFunctionDefault } from '@/utilities/translations'

import MultiSelect from '../common/ui/inputs/MultiSelect.vue'
import CreatePersonLinkedOrganizations from '../editRelationGroup/sections/CreatePersonLinkedOrganizations.vue'

const tfDefault = translationFunctionDefault()
const { canCreateTag, createNewTagOption, tagOptions } = useTagOptions()
</script>

<template>
  <SectionMetaData />
  <CreatePersonLinkedOrganizations name="links" />
  <CollapsableContent :title="tfDefault('createRelation.sectionTitleTags')">
    <MultiSelect
      allow-adding-pills
      :data-testid="TEST_IDS_CREATE.tagSelect"
      name="tw_user_tags"
      :on-create-new-pill="canCreateTag ? createNewTagOption : undefined"
      on-white-bg
      :options="[{ options: tagOptions }]"
      placeholder="Select tags"
    />
  </CollapsableContent>
  <SectionGeneralDataPerson in-create-context />
  <SectionWeblinks in-create-context />
  <SectionEmails in-create-context />
  <SectionPhoneNumbers in-create-context />
  <SectionAddresses in-create-context />
</template>
